const host = window.location.hostname;

export const redirectUri =
  host === "localhost" || host === "127.0.0.1"
    ? "http://localhost/exambits-react-axios-ownDb/auth/microsoft-callback.html"
    : host === "bits.exambridge.com"
      ? "https://bits.exambridge.com/auth/microsoft-callback.html"
      : "https://exambridge.com/auth/microsoft-callback.html";
/*
const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const redirectUri = isLocal
  ? "http://localhost/exambits-react-axios-ownDb/auth/microsoft-callback.html"
  : "https://exambridge.com/auth/microsoft-callback.html";
*/
export const msalConfig = {
  auth: {
    clientId: "07cb046d-e6e9-4d25-a0e5-4edf9e0e5b30",
    authority: "https://login.microsoftonline.com/common",
    redirectUri,
  },
  system: {
    windowHashTimeout: 30000,
    loadFrameTimeout: 30000,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

/*
const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const redirectUri = isLocal
  ? "http://localhost/exambits-react-axios-ownDb/auth/microsoft-callback.html"
  : "https://exambridge.com/auth/microsoft-callback.html";
    
export const msalConfig = {
  auth: {
    clientId: "07cb046d-e6e9-4d25-a0e5-4edf9e0e5b30",
    authority: "https://login.microsoftonline.com/common",
    redirectUri:
      "http://localhost/exambits-react-axios-ownDb/auth/microsoft-callback.html",
  },

  system: {
    windowHashTimeout: 30000,
    loadFrameTimeout: 30000,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};
*/

/*
import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "07cb046d-e6e9-4d25-a0e5-4edf9e0e5b30",
    authority: "https://login.microsoftonline.com/common",
    redirectUri:
      "http://localhost/exambits-react-axios-ownDb/auth/microsoft-callback.html",
  },
  system: {
    windowHashTimeout: 30000,
    loadFrameTimeout: 30000,
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
      loggerCallback: (level, message) => {
        console.log("[MSAL]", level, message);
      },
    },
  },
};
*/

/*
Application (client) ID:  07cb046d-e6e9-4d25-a0e5-4edf9e0e5b30
Object ID:  836b4644-7859-48ff-ade8-6fb1e966c28d
Directory (tenant) ID:  f33b4860-7ad8-4dd6-b07e-16c50cdf55f2
Secret:
Value: Fzb8Q~5zW3iPKsJr1X0oyc6EilWy~2WxL928Abbw
Expire: 9/15/2026
Secret ID:  61ac4ebf-2720-4fb3-bf32-857b7ff49204

*/
